import { makeStyles, Tooltip } from '@material-ui/core';
import React from 'react';

import { ReactComponent as ArrowIcon } from '../../static/_assets/arrow-icon.svg';
import { FONT_HEAVY } from '../../styles/fonts';

interface SectionCardRateProps {
  marketRate?: number | null;
  submissionRate?: number | null;
  compare?: boolean;
  className?: string;
  dataTestId?: string;
}

const formatCurrency = (value: number): string => {
  const formatted = value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

  return `$${formatted}`;
};

export default function SectionCardRate({
  marketRate,
  submissionRate,
  compare = false,
  className = '',
  dataTestId,
}: SectionCardRateProps) {
  const classes = useStyles();

  if (submissionRate == null) {
    return null;
  }

  const market = typeof marketRate === 'number' ? marketRate : 0;
  const showComparison = compare && market !== 0;

  const below = showComparison && market > submissionRate;
  const above = showComparison && market < submissionRate;
  const equal = showComparison && market === submissionRate;

  const comparisonScore = showComparison ? Math.abs(((submissionRate - market) / market) * 100) : 0;

  const chipColorClass = below ? classes.chipBelow : above ? classes.chipAbove : classes.chipEqual;

  return (
    <span className={`${classes.root} ${className}`} data-testid={dataTestId}>
      <span>{formatCurrency(submissionRate)}</span>
      {showComparison && (
        <Tooltip title={`Program Rate: ${formatCurrency(market)}/hr`}>
          <span className={`${classes.chip} ${chipColorClass}`}>
            {below && <ArrowIcon className={`${classes.arrow} ${classes.arrowDown}`} />}
            {above && <ArrowIcon className={classes.arrow} />}
            {equal && <span className={classes.equalSign}>@</span>}
            <span>{comparisonScore.toFixed(2)}%</span>
          </span>
        </Tooltip>
      )}
    </span>
  );
}

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    lineHeight: '20px',
  },
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    height: 20,
    marginLeft: 10,
    padding: '2px 5px',
    borderRadius: 4,
    color: '#FFFFFF',
    ...FONT_HEAVY,
  },
  chipBelow: {
    backgroundColor: '#0068ff',
  },
  chipAbove: {
    backgroundColor: '#c82639',
  },
  chipEqual: {
    backgroundColor: '#2291FC',
  },
  arrow: {
    width: 12,
    height: 12,
    marginRight: 5,
    fill: '#FFFFFF',
    '& path': {
      fill: '#FFFFFF',
    },
  },
  arrowDown: {
    transform: 'rotate(180deg)',
  },
  equalSign: {
    marginRight: 5,
  },
});
